(function () {
  "use strict";
  /* Wade Greens - distinct icons on the mobile menu rows.

     Four rows shipped the identical generic leaf glyph - Produce, Grow Sheet,
     Farmers Market and Resources - so they were indistinguishable at a glance.
     This swaps in one icon each. Nursery Plants, Fresh Sheet, Account and
     Wishlist already carry their own distinct glyphs and are NOT touched.

     The replacements are Material Design filled glyphs, the same family the
     theme's existing row icons are drawn from, so they sit inside the set
     rather than beside it. Nothing here is outline-style: the theme's row
     icons are filled, and a stroke icon next to them would read as foreign.

     Applied as a CSS mask with background-color: currentColor, so each row
     keeps whatever colour the theme already gives it - green where the theme
     is green, black where it is black. That also removes the hook iOS uses to
     repaint an icon its own link blue. The theme's <svg> is hidden, not
     removed, so reverting is one attribute.

     Matching is on the row's visible label rather than its href, because the
     labels are what gets edited in the theme editor and they survive a URL
     change. An unmatched row is left exactly as it was. */

  var MAP = [
    ["produce", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNMTcuMjEgOWwtNC4zOC02LjU2Yy0uMTktLjI4LS41MS0uNDItLjgzLS40Mi0uMzIgMC0uNjQuMTQtLjgzLjQzTDYuNzkgOUgyYy0uNTUgMC0xIC40NS0xIDEgMCAuMDkuMDEuMTguMDQuMjdsMi41NCA5LjI3Yy4yMy44NCAxIDEuNDYgMS45MiAxLjQ2aDEzYy45MiAwIDEuNjktLjYyIDEuOTMtMS40NmwyLjU0LTkuMjdMMjMgMTBjMC0uNTUtLjQ1LTEtMS0xaC00Ljc5ek05IDlsMy00LjRMMTUgOUg5em0zIDhjLTEuMSAwLTItLjktMi0ycy45LTIgMi0yIDIgLjkgMiAyLS45IDItMiAyeiIvPjwvc3ZnPg=="],
    ["grow sheet", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNMTUuNDkgOS42M2MtLjE4LTIuNzktMS4zMS01LjUxLTMuNDMtNy42My0yLjE0IDIuMTQtMy4zMiA0Ljg2LTMuNTUgNy42MyAxLjI4LjY4IDIuNDYgMS41NiAzLjQ5IDIuNjMgMS4wMy0xLjA2IDIuMjEtMS45NCAzLjQ5LTIuNjN6TTEyIDE1LjQ1QzkuODUgMTIuMTcgNi4xOCAxMCAyIDEwYzAgNS4zMiAzLjM2IDkuODIgOC4wMyAxMS40OS42NS4zNCAxLjMuNTEgMS45Ny41MXMxLjMyLS4xNyAxLjk3LS41MUMxOC42NCAxOS44MiAyMiAxNS4zMiAyMiAxMGMtNC4xOCAwLTcuODUgMi4xNy0xMCA1LjQ1eiIvPjwvc3ZnPg=="],
    ["farmers market", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNMjAgNEg0djJoMTZWNHptMSAxMHYtMmwtMS01SDRsLTEgNXYyaDF2NmgxMHYtNmg0djZoMnYtNmgxem0tOSA0SDZ2LTRoNnY0eiIvPjwvc3ZnPg=="],
    ["farmer's market", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNMjAgNEg0djJoMTZWNHptMSAxMHYtMmwtMS01SDRsLTEgNXYyaDF2NmgxMHYtNmg0djZoMnYtNmgxem0tOSA0SDZ2LTRoNnY0eiIvPjwvc3ZnPg=="],
    ["resources", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNMjEgNWMtMS4xMS0uMzUtMi4zMy0uNS0zLjUtLjUtMS45NSAwLTQuMDUuNC01LjUgMS41LTEuNDUtMS4xLTMuNTUtMS41LTUuNS0xLjVTMi40NSA0LjkgMSA2djE0LjY1YzAgLjI1LjI1LjUuNS41LjEgMCAuMTUtLjA1LjI1LS4wNUMzLjEgMjAuNDUgNS4wNSAyMCA2LjUgMjBjMS45NSAwIDQuMDUuNCA1LjUgMS41IDEuMzUtLjg1IDMuOC0xLjUgNS41LTEuNSAxLjY1IDAgMy4zNS4zIDQuNzUgMS4wNS4xLjA1LjE1LjA1LjI1LjA1LjI1IDAgLjUtLjI1LjUtLjVWNmMtLjYtLjQ1LTEuMjUtLjc1LTItMXptMCAxMy41Yy0xLjEtLjM1LTIuMy0uNS0zLjUtLjUtMS43IDAtNC4xNS42NS01LjUgMS41VjhjMS4zNS0uODUgMy44LTEuNSA1LjUtMS41IDEuMiAwIDIuNC4xNSAzLjUuNXYxMS41eiIvPjwvc3ZnPg=="]
  ];

  function iconFor(row) {
    var el = row.querySelector(".nm-row-title");
    var t = ((el ? el.textContent : "") || "").replace(/\s+/g, " ").trim().toLowerCase();
    if (!t) return null;
    for (var i = 0; i < MAP.length; i++) {
      if (t.indexOf(MAP[i][0]) === 0) return MAP[i];
    }
    return null;
  }

  function apply(badge) {
    var row = badge.parentElement;
    if (!row) return;
    var hit = iconFor(row);
    if (!hit) return;
    if (badge.getAttribute("data-wg-row-ico") === hit[0]) return;

    var svg = badge.querySelector("svg");
    if (svg) svg.setAttribute("data-wg-row-ico-hidden", "1");

    var span = badge.querySelector(".wg-row-ico");
    if (!span) {
      span = document.createElement("span");
      span.className = "wg-row-ico";
      badge.appendChild(span);
    }
    var url = 'url("' + hit[1] + '")';
    span.style.webkitMaskImage = url;
    span.style.maskImage = url;
    badge.setAttribute("data-wg-row-ico", hit[0]);
  }

  function sweep() {
    var badges = document.querySelectorAll(".nm-badge");
    for (var i = 0; i < badges.length; i++) apply(badges[i]);
  }

  function init() {
    sweep();
    try {
      var pending = null;
      new MutationObserver(function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(sweep, 80);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener("shopify:section:load", function () {
      window.setTimeout(sweep, 60);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
